import type { ValidationIssueFamilySeverity } from '../lib/validationIssueFamilies';
import { validationActionTooltips } from '../../../shared/config/actionHelpCatalog';
import ActionHelpTooltip from '../../../shared/ui/common/ActionHelpTooltip';
import { WorkspaceStatusPill } from '../../../shared/ui/workflow/WorkflowWorkspacePrimitives';

interface SeverityBadgeProps {
  severity: ValidationIssueFamilySeverity;
  validationIds?: number[] | number;
  compact?: boolean;
}

const SEVERITY_META: Record<
  ValidationIssueFamilySeverity,
  { label: string; tone: 'error' | 'warning' | 'info' }
> = {
  critical: { label: 'Critical', tone: 'error' },
  error: { label: 'Error', tone: 'error' },
  warning: { label: 'Warning', tone: 'warning' },
  info: { label: 'Info', tone: 'info' },
};

export default function SeverityBadge({ severity }: SeverityBadgeProps) {
  const meta = SEVERITY_META[severity];
  const label = meta.label;
  const tone = meta.tone;
  const help =
    severity === 'critical'
      ? validationActionTooltips.severityCritical
      : severity === 'error'
        ? validationActionTooltips.severityError
        : severity === 'warning'
          ? validationActionTooltips.severityWarning
          : validationActionTooltips.severityInfo;

  return (
    <ActionHelpTooltip help={help}>
      <span>
        <WorkspaceStatusPill label={label} tone={tone} />
      </span>
    </ActionHelpTooltip>
  );
}
